module.exports = __webpack_public_path__ + "assets/imgs/world-map.svg";